/// The breadcrumb navigator's typography and hit area, shared so a second
/// header (org settings) reads as the same control rather than a lookalike.
export const navigatorButtonClasses =
  "px-2 item-height rounded-app transition-colors hover:bg-list-hover flex items-center";
